import descbg from './desc-bg.png'
import eatch from './eatch.jpg'
import backbtnout from './backbtn-out.png'
import bedroom from './bedroom.jpg'
import credits from './credits.png'
import board from './board.jpg'
import bronze from './bronze.png'
import gold from './gold.png'
import katya from './katya.png'
import me from './me.png'
import me2 from './me2.png'
import pause from './pause.png'
import pausebutton from './pause-button.jpg'
import pc from './pc.png'
import pcscreen from './pc-screen.jpg'
import silver from './silver.png'
//bedroom
import bed from './bedroom/bed.png'
import bedout from './bedroom/bed-out.png'
import bg from './bedroom/bg.png'
import door from './bedroom/door.png'
import doorlight from './bedroom/door-light.png'
import doorout from './bedroom/door-out.png'
import pc1 from './bedroom/pc.png'
import pcout from './bedroom/pc-out.png'
import window from './bedroom/window-00.png'
import window1 from './bedroom/window-06.png'
import window2 from './bedroom/window-12.png'
//kitchen
import bedroom2 from './kitchen/bedroom.png'
import bedroomout from './kitchen/bedroom-out.png'
import bgkitch from './kitchen/bg.png'
import bucket from './kitchen/bucket.png'
import desck from './kitchen/desck.png'
import desckout from './kitchen/desk-out.png'
import fridge from './kitchen/fridge.png'
import fridgebg from './kitchen/fridge-bg.png'
import fridgeglassbg from './kitchen/fridge-glass-bg.png'
import fridgeout from './kitchen/fridge-out.png'
import mouse from './kitchen/mouse.png'
import note from './kitchen/note.png'
import note2 from './kitchen/note2.png'
import windowKitch00 from './kitchen/window-00.png'
import windowKitch06 from './kitchen/window-06.png'
import windowKitch12 from './kitchen/window-12.png'
//products
import banana from './products/banana.png'
import cheescacke from './products/cheescacke.png'
import cheese from './products/cheese.png'
import cola from './products/cola.png'
import dory from './products/dory.png'
import egg from './products/egg.png'
import energy from './products/energy.png'
import flakes from './products/flakes.png'
import focus from './products/focus.png'
import jem from './products/jem.png'
import kelbasa from './products/kelbasa.png'
import milk from './products/milk.png'
import papper from './products/papper.png'
import peach from './products/peach.png'
import salami from './products/salami.png'
import sausages from './products/sausages.png'
import spickers from './products/spickers.png'
import tomato from './products/tomato.png'

export const IMG_ASSETS = [
  descbg,
  eatch,
  backbtnout,
  bedroom,
  credits,
  board,
  bronze,
  gold,
  katya,
  me,
  me2,
  pause,
  pausebutton,
  pc,
  pcscreen,
  silver,
  bed,
  bedout,
  bg,
  door,
  doorlight,
  doorout,
  pc1,
  pcout,
  window,
  window1,
  window2,
  bedroom2,
  bedroomout,
  bgkitch,
  bucket,
  desck,
  desckout,
  fridge,
  fridgebg,
  fridgeglassbg,
  fridgeout,
  mouse,
  note,
  note2,
  windowKitch00,
  windowKitch06,
  windowKitch12,
  banana,
  cheescacke,
  cheese,
  cola,
  dory,
  egg,
  energy,
  flakes,
  focus,
  jem,
  kelbasa,
  milk,
  papper,
  peach,
  salami,
  sausages,
  spickers,
  tomato,
]